import { useContext, useMemo } from "react";
import UserContext from "../../../contexts/UserContext";
import { useParams } from "react-router-dom";
import { useAppSelector } from "./storeHooks";
import { selectCredByRef } from "../reducers/credentialsSlice";
import { ICredential } from "../types/credential";

interface IUseIsUserCredOwnerParams {
  credentialParam?: ICredential | undefined;
}

export const useIsUserCredOwner = ({ credentialParam }: IUseIsUserCredOwnerParams) => {
  const user = useContext(UserContext);

  const { credentialId } = useParams();
  const credential = useAppSelector((state) =>
    selectCredByRef(state, credentialId!)
  );

  const isUserCredOwner = useMemo(() => {
    const loggedInUserId = user.getUser().uid;
    return loggedInUserId === (credentialParam ? credentialParam.uid : credential ? credential.uid : undefined);
  }, [credential, user, credentialParam]);

  return isUserCredOwner;
};